import React, { useEffect, useState } from "react";
import {
  CometChatActionsIcon,
  CometChatMessageEvents,
  CometChatUIKit,
} from "@cometchat/chat-uikit-react";
import { CometChat } from "@cometchat/chat-sdk-javascript";
import deleteIcon from '../../CometChat/assets/deleteicon.svg';
import CometChatApp from "../../CometChat/CometChatApp";
import { useCometChatInit } from "./hooks/useCometChatInit";
import AdminDeleteChatMessageDialog from "../../components/Dialogs/AdminDeleteChatMessageDialog";

const AdminChat = () => {
  const { isInitialized, error } = useCometChatInit();
  const [refreshKey, setRefreshKey] = useState(0);
  const [showDeleteMessageDialog, setShowDeleteMessageDialog] = useState<boolean>(false);
  const [messageToDelete, setMessageToDelete] = useState<string>("");

  const deleteMessage = () => {
    const message = messageToDelete;
    CometChat.deleteMessage(message)
      .then((deletedMessage) => {
        console.log("Message deleted successfully by admin", deletedMessage);
        CometChatMessageEvents.ccMessageDeleted.next(deletedMessage);
        setShowDeleteMessageDialog(false);
      })
      .catch((error) => {
        console.error("Message deletion failed", error);
        alert("Ocurrio un error al intentar borrar el mensaje");
      });
  };

  useEffect(() => {
    // Only setup if CometChat is initialized
    if (!isInitialized || error) return;

    // Setup custom message options when component mounts
    setupAdminDeleteOption();

    // Subscribe to message deleted events
    const ccMessageDeleted = CometChatMessageEvents.ccMessageDeleted.subscribe((deletedMessage: CometChat.BaseMessage) => {
      console.log("Message deleted event received:", deletedMessage);
      setRefreshKey(prevKey => prevKey + 1);
    });

    // Cleanup subscription on unmount
    return () => {
      ccMessageDeleted.unsubscribe();
    };
  }, [isInitialized, error]);

  const setupAdminDeleteOption = () => {
    // Override the getMessageOptions method in the DataSource
    const dataSource = CometChatUIKit.getDataSource();
    const originalGetMessageOptions = dataSource.getMessageOptions.bind(dataSource);

    dataSource.getMessageOptions = (
      loggedInUser: CometChat.User,
      message: CometChat.BaseMessage,
      theme?: any,
      group?: CometChat.Group
    ) => {
      // Get default options
      const defaultOptions = originalGetMessageOptions(loggedInUser, message, theme, group);

      // Check if user is admin
      const isAdmin = (loggedInUser as any).role === "admin";

      // Check if message is from another user
      const isOtherUsersMessage = message.getSender().getUid() !== loggedInUser.getUid();

      // If admin and it's another user's message, add delete option
      if (isAdmin && isOtherUsersMessage) {
        // Check if admin delete option already exists
        const hasAdminDelete = defaultOptions.some((opt: any) => opt.id === "admin-delete");

        if (!hasAdminDelete) {
          const deleteOption = new CometChatActionsIcon({
            id: "admin-delete",
            title: "Borrar Mensaje (Admin)",
            iconURL: deleteIcon,
            onClick: () => {
              setMessageToDelete(message.getId().toString());
              setShowDeleteMessageDialog(true);
            },
          });

          // Add delete option
          defaultOptions.push(deleteOption);
        }
      }

      return defaultOptions;
    };
  };

  // Show loading state while initializing
  if (!isInitialized) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100vw",
        height: "100vh"
      }}>
        <div>Cargando CometChat...</div>
      </div>
    );
  }

  // Show error state if initialization failed
  if (error) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100vw",
        height: "100vh"
      }}>
        <div>
          <p>Error al inicializar CometChat: {error.message}</p>
          <p>Por favor, intenta recargar la página.</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <h1 className="text-center">Chats de eventos</h1>
      <style>{`
        .cometchat__messageactions,
        .cometchat-menu-list__sub-menu-list{
          min-width: 220px !important;
          width: auto !important;
        }
      `}</style>
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100vw",
        height: "90vh"
      }}>

        <div style={{ width: "90vw", height: "80vh" }}>
          <CometChatApp key={refreshKey} />
          <AdminDeleteChatMessageDialog
            visible={showDeleteMessageDialog}
            onHide={() => { setShowDeleteMessageDialog(false); }}
            onSubmit={deleteMessage}
          />
        </div>
      </div>
    </>
  );
};

export default AdminChat;